(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/login-self-exclusion.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/login-self-exclusion.js');
'use strict';

const Button = svs.ui.ReactButton;
const isMobile = svs.core.detect.formfactor.mobile();
const URL = svs.selfExclusion.Constants.URL;
const LoginSelfExclusion = () => React.createElement(React.Fragment, null, React.createElement("section", {
  className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2"
}, React.createElement("div", null, React.createElement("h2", {
  className: "f-550 align-center suspension-title"
}, React.createElement("span", {
  className: "suspension-title-text"
}, "Spelpaus")), React.createElement("p", null, "P\xE5 spela.svenskaspel.se kan du pausa dig fr\xE5n spel i 24 timmar, 3 m\xE5nader, 6 m\xE5nader, 1 \xE5r eller 3 \xE5r. F\xF6r att ta en paus beh\xF6ver du vara inloggad.", ' ', isMobile && React.createElement("a", {
  href: URL.READ_MORE
}, "L\xE4s mer om spelpaus h\xE4r"))), React.createElement(Button, {
  block: true,
  href: URL.LOG_IN,
  inverted: true,
  size: 300
}, "Logga in")), React.createElement("hr", {
  "aria-hidden": true,
  className: "exclusion-border-bottom"
}));
svs.selfExclusion.components.LoginSelfExclusion = LoginSelfExclusion;

 })(window);